import type { DocumentCategory, SummaryItem } from "./types";

export const COURSE_CERTIFICATES_PAGE_SIZE = 20;
export const REDUCTIONS_PAGE_SIZE = 20;
export const LEGAL_AID_PAGE_SIZE = 20;
export const TEACHINGS_PAGE_SIZE = 20;
export const AUTHORSHIPS_PAGE_SIZE = 20;
export const DISPENSATIONS_PAGE_SIZE = 20;
export const INSURANCE_POLICIES_PAGE_SIZE = 20;

export const summaryItems: SummaryItem[] = [
  {
    label: "Aktuel periode",
    value: "01.01.2024 - 31.12.2026",
    helpText: "Næste frist: 31.03.2027",
  },
  {
    label: "Registrerede lektioner",
    value: "42 / 54",
    helpText: "12 lektioner mangler",
  },
  {
    label: "Påbud",
    value: "1 aktivt",
    helpText: "Frist: 15.06.2026",
  },
  {
    label: "Dispensationer",
    value: "2 godkendte",
    helpText: "Senest godkendt 10.02.2026",
  },
];

export const documentCategories: DocumentCategory[] = [
  {
    id: "kursusbeviser",
    title: "Kursusbeviser",
    description: "Dokumentation for gennemførte kurser og lektioner.",
  },
  {
    id: "reduktioner",
    title: "Reduktioner",
    description: "Dokumenter relateret til reduktion af lektionskrav.",
  },
  {
    id: "advokatvagt-retshjaelp",
    title: "Advokatvagt/retshjælp",
    description:
      "Dokumentation for frivillig rådgivning i advokatvagter og på retshjælpskontorer.",
  },
  {
    id: "forfatterskab",
    title: "Forfatterskab",
    description: "Dokumentation for artikler, bøger og andet forfatterskab.",
  },
  {
    id: "undervisning",
    title: "Undervisning",
    description: "Dokumentation for undervisning og oplæg.",
  },
  {
    id: "forsikringspolicer",
    title: "Forsikringspolicer",
    description: "Dokumentation for advokatforsikring og garantistillelse.",
  },
];
